import { countries_options } from "@/components/Form/CountryPhone/data";
import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { preprocessTextAsyncAutocompleteField } from "@/features/FormCard/utils";
import { z } from "zod";
import { useTranslation } from "react-i18next";

const filterE3IssuersSchema = z.object({
  name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  country_contains: z.string().optional(),
  sector_contains: z.string().optional(),
});

export type FilterE3IssuersSchema = z.infer<typeof filterE3IssuersSchema>;

export function FilterE3Issuers() {
  const { t, i18n } = useTranslation(["common", "tables"]);
  const client = "e3";
  const tableName = "e3_issuers";
  const language = i18n.language?.startsWith("en") ? "en" : "fr";

  const fields: Field[] = [
    {
      name: "name_contains",
      label: t(`${tableName}.columns.name`, {
        ns: "tables",
        defaultValue: "Name",
      }),
      type: "asyncAutocomplete",
      base_url: "e3/e3_issuers",
      column_name: "name",
    },
    {
      name: "country_contains",
      label: t(`${tableName}.columns.country_name`, {
        ns: "tables",
        defaultValue: "Country",
      }),
      type: "autocomplete",
      options: countries_options,
    },
    {
      name: "sector_contains",
      label: t(`${tableName}.columns.sector`, {
        ns: "tables",
        defaultValue: "Sector",
      }),
      type: "select",
      useTranslation: true,
      client,
      table_name: tableName,
      language,
      translate_key: "sector",
    },
  ];

  return (
    <FilterTable
      client={client}
      schema={filterE3IssuersSchema}
      tableName={tableName}
      fields={fields}
    />
  );
}
